import type {TAdminSignUpsResponse} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import type {TSignupRequestId} from '@kapitalist/contract/types'
import type {EmptyObject} from '@kapitalist/utils/EmptyObject'
import {PostApi} from '~/api/client'
import type {TAdminSignUpsResult} from '~/api/endpoints/admin/AdminSignUps'
import {
  AdminSignupsMock,
  transformAdminSignUpsResponse,
} from '~/api/endpoints/admin/AdminSignUps'

const endpoint = endpoints.admin.approveSignUp

export default class AdminApproveSignUp extends PostApi<
  typeof endpoint,
  TAdminSignUpsResult
>() {
  constructor() {
    super(endpoint)
  }

  protected getMockResponse(
    params: EmptyObject,
    pathPieces: {signupRequestId: TSignupRequestId}
  ): TAdminSignUpsResponse {
    return {
      signupRequests: AdminSignupsMock.filter(
        asm => asm.id !== pathPieces.signupRequestId
      ),
    }
  }

  protected transformResponse(r: TAdminSignUpsResponse): TAdminSignUpsResult {
    return transformAdminSignUpsResponse(r)
  }
}
